import { Segment, SegmentProps } from "semantic-ui-react";

type BPSegmentProps = SegmentProps & {};

export function BPSegment(props: BPSegmentProps) {
    return <Segment {...props}>{props.children}</Segment>;
}